{
    " New": " New",
    ":New": ": New",
    ":Questions": ": Questions",
    "action": "Action",
    "actions": "Actions",
    "active": "Active",
    "add": "Add",
    "addedSuccessfully": "Added Successfully",
    "addFeature": "Add Feature",
    "addPricing": "Add Pricing",
    "addQuestion": "Add Question",
    "addReferral": "Add Referral",
    "address": "Address",
    "addSchedule": "Add Schedule",
    "addTenantMenuGroup": "Add Tenant Menu Group",
    "advancedSearch": "Advanced Search",
    "ai": "AI",
    "aiModelDisclaimer": "Contents generated from AI may not be perfect. Teachers are suggested to review the generated contents carefully.",
    "aiModelNotSatisfiedMessage": "Not Satisfied with AI generated questions? You can change the topics and try again.",
    "aiQuestionPhraseTitle": "Ai Question Phrase Title",
    "aiQuestions": "AI Questions",
    "answer": "Answer",
    "appreciation": "Appreciation",
    "areYouSure": "Are You Sure?",
    "ay": "AY",
    "backToSession": "Back To Session",
    "badge": "Badge",
    "badges": "Badges",
    "birthDate": "Birth Date",
    "buyerCategory": "Buyer Category",
    "cancel": "Cancel",
    "cancelSession": "Cancel Session",
    "category": "Category",
    "cc": "Cc",
    "change": "Change",
    "changePassword": "Change Password",
    "children": "Children",
    "city": "City",
    "class": "Class",
    "class: New": "Class: New",
    "class:New": "Class: New",
    "classCode": "Class Code",
    "classes": "Classes",
    "className": "Class Name",
    "classwise": "Classwise",
    "code": "Code",
    "columns": "Columns",
    "companies": "Companies",
    "confirmation": "Confirmation",
    "count": "Count",
    "country": "Country",
    "couponCount": "Coupon Count",
    "couponExpireDate": "Coupon Expire Date",
    "createDate": "Create Date",
    "createdBy": "Created By",
    "createdBy_delete": "Created By_delete",
    "createdDate": "Created Date",
    "dashboard": "Dashboard",
    "dataSetup": "Data Setup",
    "dataSetup_Duplicate": "Data Setup_Duplicate",
    "delete": "Delete",
    "description": "Description",
    "difficultyLevel": "Difficulty Level",
    "dirtyCheckMessage": "Unsaved changes will be lost. Are you sure you want to navigate away?",
    "displayName": "Display Name",
    "downloadExcelTemplate": "Download Excel Template",
    "duplicateUserMessage": "Duplicate user found with this email. Please contact administrator",
    "duration": "Duration (min.)",
    "dutch": "Dutch",
    "edit": "Edit",
    "editSession": "Edit Session",
    "email": "Email",
    "emailTemplates": "Email Templates",
    "endDate": "End Date",
    "english": "English",
    "examResults": "Exam Results",
    "examSchedule": "Exam Schedule",
    "examScheduleMessage": "When exam schedule is changed, any quiz mapping related to the exam schedule may be lost without any further\n            notice. Please make sure before making any changes to the schedule.",
    "examSchedules": "Exam Schedules",
    "expiryDate": "Expiry Date",
    "exportData": "Export Data",
    "faqs": "Faqs",
    "feature": "Feature",
    "feature_duplicate": "Feature",
    "features": "Features",
    "features_duplicate": "Features",
    "feedback": "Feedback",
    "feedbackSentSuccesfully": "Feedback Sent Succesfully",
    "feedbackType": "Feedback Type",
    "firstName": "First Name",
    "forgotPassword": "Forgot Password",
    "forMobileApp": "For Mobile App",
    "forwardKey": "Forward Key",
    "free": "Free",
    "free_duplicate": "Free",
    "gameIds": "Game Ids",
    "games": "Games",
    "gender": "Gender",
    "generateQuestionsFrom": "Generate Questions From",
    "german": "German",
    "gold": "Gold",
    "grade": "Grade",
    "gradings": "Gradings",
    "grid": "Grid",
    "gridColumns": "Grid Columns",
    "groupName": "Group Name",
    "uuid": "Guid",
    "hello": "Hello",
    "home": "Home",
    "hostConfig": "Host Config",
    "hostConfigs": "Host Configs",
    "hostname": "Hostname",
    "id": "Id",
    "imageUrl": "Image Url",
    "importData": "Import Data",
    "improvement": "Improvement",
    "includeExpired": "Include Expired",
    "invalidCredentialsMessage": "Invalid Credentials",
    "ipAddress": "IP Address",
    "isActive": "Is Active",
    "isMostPopular": "Is Most Popular",
    "key": "Key",
    "language": "Language",
    "lastName": "Last Name",
    "level": "Level",
    "line1": "Line1",
    "line2": "Line2",
    "line3": "Line3",
    "line4": "Line4",
    "line5": "Line5",
    "line6": "Line6",
    "line7": "Line7",
    "line8": "Line8",
    "loadFromQuestionBank": "Load From Question Bank",
    "location": "Location",
    "login": "Login",
    "loginAgain": "Login Again",
    "loginPageMessage": "Welcome to the high class, professional and innovative education system.",
    "loginWith": "Login With",
    "manageNoticeBoard": "Manage Notice Board",
    "marks": "Marks",
    "maxLength": "Max Length",
    "menu": "Menu",
    "menuGroup": "Menu Group",
    "menuGroups": "Menu Groups",
    "menuIds": "Menu Ids",
    "menus": "Menus",
    "menuType": "Menu Type",
    "messageSentSuccesfully": "Message Sent Succesfully",
    "messageSubscribers": "Message Subscribers",
    "messageToAllSubscribers": "Message To All Subscribers",
    "minimumContractDuration": "Minimum Contract Duration",
    "my": "MY",
    "myExamResults": "My Exam Results",
    "myProfile": "My Profile",
    "myReferrals": "My Referrals",
    "name": "Name",
    "new": "New",
    "newPasswordAndConfirmPasswordDoNotMatch": "New Password And Confirm Password Do Not Match",
    "noQuestionHere": "No Question Here",
    "noticeBoard": "Notice Board",
    "onlyAvailableWithAnnualPlan": "Only Available With Annual Plan",
    "owner": "Owner",
    "parentId": "Parent Id",
    "password": "Password",
    "passwordChangedSuccesfully": "Password Changed Succesfully",
    "path": "Path",
    "phone": "Phone",
    "platinum": "Platinum",
    "playlists": "Playlists",
    "pleaseAddQuestions": "Please Add Question(s) to continue",
    "pleaseEnterAllFields": "Please Enter All Fields",
    "pleaseNote": "Please Note",
    "pleaseSelect": "Please Select",
    "pleaseTypeAnswerHere": "Please Type Answer Here",
    "pleaseTypeNumberAnswerHere": "Please Type Answer Here (Number Only)",
    "price": "Price",
    "priceYearly": "Price Yearly",
    "pricing": "Pricing",
    "pricingRanges": "Pricing Ranges",
    "pricings": "Pricings",
    "pricingType": "Pricing Type",
    "proctorQuiz": "Proctor Quiz",
    "proctorScore": "Proctor Score",
    "profile": "Profile",
    "profileUpdatedSuccessfully": "Profile Updated Successfully",
    "prompt": "Prompt",
    "question": "Question",
    "questionBank": "Question Bank",
    "questionBanks": "Question Banks",
    "questionBanksLimit": "Question Banks Limit",
    "questionCount": "Question Count",
    "questions": "Questions",
    "questionSetup": "Question Setup",
    "questionTopic": "Question Topic",
    "questionType": "Question Type",
    "quiz": "Quiz",
    "quizCode": "Quiz Code",
    "quizConfig": "Quiz Config",
    "quizConfigs": "Quiz Configs",
    "quizResult": "Quiz Result",
    "quizResults": "Quiz Results",
    "quizType": "Quiz Type",
    "quizzes": "Quizzes",
    "range": "Range",
    "records": "Records",
    "referralCode": "Referral Code",
    "referrals": "Referrals",
    "refreshCache": "Refresh Cache",
    "register": "Register",
    "reset": "Reset",
    "retrievePassword": "Retrieve Password",
    "save": "Save",
    "saveAndClose": "Save and Close",
    "savedSuccessfully": "Saved Successfully",
    "saving": "Saving",
    "scheduleAddedSuccessfully": "Schedule Added Successfully",
    "scheduleCouldNotBeAddedSuccessfully": "Schedule Could Not Be Added Successfully",
    "school": "School",
    "schoolName": "School Name",
    "schoolOwnerName": "School Owner Name",
    "schoolType": "School Type",
    "search": "Search",
    "section": "Section",
    "select": "Select",
    "sendFeedback": "Send Feedback",
    "sendMessage": "Send Message",
    "sendMessageToSubscribers": "Send Message To Subscribers",
    "sessionCanceledSuccessfully": "Session Canceled Successfully",
    "sessionsToAttend": "Sessions To Attend",
    "sessionsToDeliver": "Sessions To Deliver",
    "sessionUpdatedSuccesfully": "Session Updated Succesfully",
    "shared": "Shared",
    "shareMessage": "Are you sure you want to share this Question Bank? <br />             Please note that once question bank is shared, you can not revert it back.",
    "shareMessageFootnote": "Before you share, you should check you are not revealing any confidential information in question banks.",
    "shareQuestionBank": "Share Question Bank",
    "showAll": "Show All",
    "shuffle": "Shuffle",
    "silver": "Silver",
    "skip": "Skip",
    "sortOrder": "Sort Order",
    "spanish": "Spanish",
    "startDate": "Start Date",
    "state": "State",
    "status": "Status",
    "student": "Student",
    "studentDiscussion": "Student Discussion",
    "studentName": "Student Name",
    "students": "Students",
    "studentsLimit": "Students Limit",
    "subject": "Subject",
    "subjectCode": "Subject Code",
    "subjects": "Subjects",
    "subjectwise": "Subjectwise",
    "submit": "Submit",
    "subscribers": "Subscribers",
    "suggestion": "Suggestion",
    "support": "Support",
    "t1": "T1",
    "t2": "T2",
    "t3": "T3",
    "t4": "T4",
    "target": "Target",
    "teacher": "Teacher",
    "teachers": "Teachers",
    "teachersLimit": "Teachers Limit",
    "template": "Template",
    "tenant": "Tenant",
    "tenantMenuGroups": "Tenant Menu Groups",
    "tenantMenus": "Tenant Menus",
    "thanksForUsingShikshawith": "Thanks For Using Shikshawith",
    "title": "Title",
    "to": "To",
    "tone": "Tone",
    "total": "Total",
    "totalMarks": "Total Marks",
    "translationKey": "Translation Key",
    "translations": "Translations",
    "trialDays": "Trial Days",
    "uId": "UId",
    "uploadFromExcel": "Upload From Excel",
    "url": "Url",
    "userId": "User Id",
    "username": "Username",
    "viewSubscribers": "View Subscribers",
    "welcomeToShikshawith": "Welcome To Shikshawith",
    "zip": "Zip"
}